import { AppointmentID } from "./Appointment";
import { CarID } from "./Car";
import { DealerID } from "./Dealer";
import { DealerLocationID } from "./DealerLocation";
import { InterventionID } from "./Intervention";
import { Pin } from "./Pin";
import { QuestionResultID } from "./QuestionResult";
import { User, UserID } from "./User";

export type ManufacturerRequestID = number;

export enum MANUFACTURER_REQUEST_STATUSES {
  Pending = 1,
  Approved = 2,
  Declined = 3
}

export interface ManufacturerRequest {
  created_on: string;
  updated_on: string;
  id: ManufacturerRequestID;
  appointment_id: AppointmentID; // Identifier of the associated appointment
  car_id: CarID; // Identifier of the car related to the request
  intervention_id: InterventionID | null; // Optional identifier for the related intervention
  question_result_id: QuestionResultID | null; // Optional identifier for the related question result
  manufacturer_id: UserID; // Identifier of the manufacturer user
  dealer_id: DealerID; // Identifier of the dealer
  dealer_location_id: DealerLocationID; // Identifier of the dealer location
  request_reason: string; // Reason why the request was made
  decline_reason: string; // Reason why the request was declined, if applicable
  status: MANUFACTURER_REQUEST_STATUSES; // Current status of the manufacturer request
  updated_by_id: UserID | null; // Identifier of the user who last updated the request
  expire_on: string | null; // Optional expiration date of the request
  pin_history?: Pin[]; // History of PIN entries related to the request
  updated_by?: User; // User who last updated the request
  manufacturer?: User; // Manufacturer user associated with this request
}
